import { put } from 'redux-saga/effects'
import importer from 'common/importer'
const CentersActions = importer('Stores/Centers/Actions')
const { getDonorCentersAll } = importer('APIs/centers', null)
export default function * main ({ searchStr }) {
  try {
    yield put(CentersActions.registerGetCentersLoading())
    const res = yield getDonorCentersAll(searchStr)
    yield put(CentersActions.registerGetCentersSuccess(res))
  } catch (error) {
    yield put(CentersActions.registerGetCentersFailure(error))
  }
}
